export const employeeRoles = [
  {
    label: 'Основатель компании',
    value: 'Основатель компании'
  },
  {
    label: 'Генеральный директор',
    value: 'Генеральный директор'
  },
  {
    label: 'Топ-менеджер компании',
    value: 'Топ-менеджер компании'
  },
  {
    label: 'Руководитель отдела',
    value: 'Руководитель отдела'
  },
  {
    label: 'Руководитель группы',
    value: 'Руководитель группы'
  },
  {
    label: 'Специалист отдела',
    value: 'Специалист отдела'
  },
  {
    label: 'Менеджер отдела',
    value: 'Менеджер отдела'
  },
  {
    label: 'Подрядчик',
    value: 'Подрядчик'
  },
  {
    label: 'Другое',
    value: 'Другое'
  },
];

export const companySizes = [
  {
    label: '1-15',
    value: '1-15 сотрудников'
  },
  {
    label: '15-100',
    value: '15-100 сотрудников'
  },
  {
    label: '100-250',
    value: '100-250 сотрудников'
  },
  {
    label: 'Более 250',
    value: 'Более 250 сотрудников'
  },
];

export const contragentTypes = {
  entity: 'E', individual: 'IP', person: 'P'
};

export const counteragentSortings = {
  entity: [
    'name',
    '-name',
    'fullName',
    '-fullName',
    'createdAt',
    '-createdAt'
  ],
  individual: [
    'name',
    '-name',
    'fullName',
    '-fullName',
    'createdAt',
    '-createdAt'
  ],
  person: [
    'name',
    '-name',
    'createdAt',
    '-createdAt'
  ]
};
